﻿import { isValidMessage } from "./message.js";
/**
 * Checks if a given message is a message sent by the iframe or not.
 * @param message Message to be checked.
 * @return true if message is from iframe.
 */
export const isValidIframeMessage = /* #__PURE__ */ function (message) {
    return (isValidMessage(message) && message.source === "iframe");
};
